export class AssignCard {
  tempCardNumber: number;
  newCardNumber: number;

  constructor(tempCardNumber: number, newCardNumber: number) {
    this.tempCardNumber = tempCardNumber;
    this.newCardNumber = newCardNumber;
  }
}
